import * as mt from './mutation-types';
import { User } from './types'

export default {
  [mt.USER_REQUEST](state: User) {
    state.status = 'loading';
  },
  [mt.USER_SUCCESS](state: User, payload: { username: string; userId: number; name: string; email: string; companyName: string;
    companyDoc: string;
    companyZipCode: string;
    companyAddress: string;
    companyPhone: string;
    companyTrial: boolean;
    companyAnalysisCount: number;
    companyFarmsCount: number;
    companyAnalitica: boolean;
    companySentinela: boolean;
    companyId: string;
    authorities: [],
    companyClientId: string | null;}
    ) {
    state.username = payload.username;
    state.userId = payload.userId;
    state.name = payload.name;
    state.email = payload.email;
    state.status = 'success';
    state.companyName = payload.companyName;
    state.companyDoc = payload.companyDoc;
    state.companyZipCode = payload.companyZipCode;
    state.companyAddress = payload.companyAddress;
    state.companyPhone = payload.companyPhone;
    state.companyTrial = payload.companyTrial;
    state.companyAnalysisCount = payload.companyAnalysisCount;
    state.companyFarmsCount = payload.companyFarmsCount;
    state.companyAnalitica = payload.companyAnalitica;
    state.companySentinela = payload.companySentinela;
    state.companyId = payload.companyId;
    state.companyClientId = payload.companyClientId;
    state.authorities = payload.authorities;
  },
  [mt.USER_ERROR](state: User) {
    state.status = 'error';
  },
  [mt.USER_LOGOUT](state: User) {
    state.username = '';
    state.userId = null;
    state.name = '';
    state.email = '';
    state.status = '';
    state.companyName = '';
    state.companyDoc = '';
    state.companyZipCode = '';
    state.companyAddress = '';
    state.companyPhone = '';
    state.companyTrial = false;
    state.companyAnalysisCount = 0;
    state.companyFarmsCount = 0;
    state.companyAnalitica = false;
    state.companySentinela = false;
    state.companyId = '';
    state.companyClientId = null;
  },
};
